module.exports = __webpack_public_path__ + "static/img/shixun.d326c350.png";